import React from "react";

// react-bootstrap components
import {
  Badge,
  Button,
  ButtonGroup,
  Card,
  Dropdown,
  Form,
  InputGroup,
  Navbar,
  Nav,
  Pagination,
  Container,
  Row,
  Col,
  Collapse,
  Image,
  Modal,
} from "react-bootstrap";
import { getNotifikasi, logout, getDetailIncidentReport, showUrlDokumen, updateIncidentReport, updateIsReadUserNotification } from "../../stores";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Select from "react-select";
import ReactDatetime from "react-datetime";
import Swal from "sweetalert2";
import { ColorRing } from "react-loader-spinner";
import {
  VerticalTimeline,
  VerticalTimelineElement,
} from "react-vertical-timeline-component";
import { socket } from "services/socket";
const getNotificationIcon = (tipe) => {
  const t = tipe || "";
  if (t === "Action_Required") {
    return {
      icon: "fas fa-exclamation-triangle",
      color: "#d9534f",
      bgColor: "#fdf3f2",
      label: "Action Required"
    };
  }
  if (t === "In_Progress") {
    return {
      icon: "fas fa-clock",
      color: "#f0ad4e",
      bgColor: "#fef8ec",
      label: "In Progress"
    };
  }
  if (t === "Closed") {
    return {
      icon: "fas fa-check-circle",
      color: "#28a745",
      bgColor: "#f4faf5",
      label: "Closed"
    };
  }
  return {
    icon: "fas fa-info-circle",
    color: "#17a2b8",
    bgColor: "#f0fbfc",
    label: t
  };
};

function AdminNavbar() {
  const dispatch = useDispatch();
  const incident = useSelector((state) => state.incidentReducer);
  React.useEffect(() => {
    getNotifikasi(dispatch);
  }, []);

  React.useEffect(() => {
    // 1. Ambil data user dari localStorage / Redux state Anda
    const userId = localStorage.getItem("id");
    if (userId) {
      // 2. Koneksikan socket
      socket.connect();
      // 3. Gabung ke room pribadi berdasarkan User ID
      socket.emit("join", userId);

      // Listen for new notifications
      socket.on("notif_baru", (data) => {
        getNotifikasi(dispatch);

        const pesan = data?.notificationId?.pesan || "Ada notifikasi baru";
        const tipe = data?.notificationId?.tipe || "";

        let iconType = "info";
        if (tipe === "Action_Required") {
          iconType = "warning";
        } else if (tipe === "Closed") {
          iconType = "success";
        }

        Swal.fire({
          toast: true,
          position: "top-end",
          icon: iconType,
          title: pesan,
          showConfirmButton: false,
          timer: 5000,
          timerProgressBar: true,
        });
      });
    }
    // Clean up: putuskan koneksi socket saat component unmount (misal user logout)
    return () => {
      socket.off("notif_baru");
      socket.disconnect();
    };
  }, [dispatch])

  const [listNotifikasi, setListNotifikasi] = React.useState([]);
  const [collapseOpen, setCollapseOpen] = React.useState(false);
  const [modal, setModal] = React.useState(false);
  const [dataDetailIncident, setDataDetailIncident] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const [dariTgl, setDariTgl] = React.useState(new Date());
  const [modalPreviewFoto, setModalPreviewFoto] = React.useState("");
  const [gambar, setGambar] = React.useState([]);
  const [deskripsi, setDeskripsi] = React.useState("");
  const [tindakan, setTindakan] = React.useState({
    value: "",
    label: "Choose the Action",
    isDisabled: true,
  });



  React.useEffect(() => {
    const detail = incident.getDetailIncidentReport && incident.getDetailIncidentReport[0];
    if (detail) {
      setDataDetailIncident(detail);

      // Fetch images/documents if there is history
      if (detail.History && detail.History.length > 0) {
        const urlImageData = detail.History.flatMap((bukti) => {
          if (Array.isArray(bukti.dokumentasi) && bukti.dokumentasi.length > 0) {
            return bukti.dokumentasi.map((img) => ({
              idDokumentasi: bukti._id,
              imgUrl: img,
            }));
          }
          return [
            {
              idDokumentasi: bukti._id,
              imgUrl: "",
            },
          ];
        });

        const filterUrl = urlImageData.filter((data) => data.imgUrl);
        if (filterUrl.length > 0) {
          const formatUrl = {
            urlImage: filterUrl.map((data) => ({
              idDokumentasi: data.idDokumentasi,
              imageUrl: data.imgUrl,
            })),
          };

          setLoading(true);
          showUrlDokumen(dispatch, formatUrl).then((response) => {
            setLoading(false);
            if (response?.data?.url) {
              setDataDetailIncident((prevData) => ({
                ...prevData,
                urlPreview: response.data.url,
              }));
            }
          }).catch((err) => {
            setLoading(false);
            console.error("Error fetching document URL:", err);
          });
        }
      }
    }
  }, [incident.getDetailIncidentReport, dispatch]);

  React.useEffect(() => {
    if (incident.getNotifikasi) {
      if (Array.isArray(incident.getNotifikasi)) {
        setListNotifikasi(incident.getNotifikasi);
      } else if (Array.isArray(incident.getNotifikasi.data)) {
        setListNotifikasi(incident.getNotifikasi.data);
      }
    }
  }, [incident.getNotifikasi]);
  return (
    <>
      <style>{`
        .notification-item {
          background-color: #ffffff !important;
          color: inherit !important;
          border-bottom: 1px solid #eeeeee !important;
        }
        .notification-item:hover,
        .notification-item:focus,
        .notification-item:active {
          background-color: #f8f9fa !important;
          color: inherit !important;
          text-decoration: none !important;
        }
        .notification-item:last-child {
          border-bottom: none !important;
        }
      `}</style>
      <Navbar expand="lg">
        <Container fluid>
          <div className="navbar-wrapper">
            <div className="navbar-minimize">
              <Button
                className="btn-fill btn-round btn-icon d-none d-lg-block bg-dark border-dark"
                variant="dark"
                onClick={() => document.body.classList.toggle("sidebar-mini")}
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
              <Button
                className="btn-fill btn-round btn-icon d-block d-lg-none bg-dark border-dark"
                variant="dark"
                onClick={() =>
                  document.documentElement.classList.toggle("nav-open")
                }
              >
                <i className="fas fa-ellipsis-v visible-on-sidebar-regular"></i>
                <i className="fas fa-bars visible-on-sidebar-mini"></i>
              </Button>
            </div>
            {/* <Navbar.Brand href="#pablo" onClick={(e) => e.preventDefault()}>
              Buttons
            </Navbar.Brand> */}
          </div>
          <button
            className="navbar-toggler navbar-toggler-right border-0"
            type="button"
            onClick={() => setCollapseOpen(!collapseOpen)}
          >
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
            <span className="navbar-toggler-bar burger-lines"></span>
          </button>
          <Navbar.Collapse className="justify-content-end" in={collapseOpen}>
            {/* <Nav className="nav mr-auto" navbar>
              <Form
                className="navbar-form navbar-left navbar-search-form ml-3 ml-lg-0"
                role="search"
              >
                <InputGroup>
                  <i className="nc-icon nc-zoom-split"></i>
                  <Form.Control
                    defaultValue=""
                    placeholder="Search..."
                    type="text"
                  ></Form.Control>
                </InputGroup>
              </Form>
            </Nav> */}
            <Nav navbar>
              {/* <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-165516306"
                  variant="default"
                >
                  <i className="nc-icon nc-planet"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Create New Post
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Manage Something
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Do Nothing
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Submit to live
                  </Dropdown.Item>
                  <li className="divider"></li>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    Another action
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown> */}
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-414718872"
                  variant="default"
                >
                  <i className="nc-icon nc-bell-55 mr-1"></i>
                  {(() => {
                    const total = incident.getNotifikasi.totalNotifikasi;
                    return total > 0 ? (
                      <span className="notification">{total}</span>
                    ) : null;
                  })()}
                  <span className="d-lg-none">Notification</span>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  style={{
                    minWidth: "320px",
                    maxWidth: "400px",
                    padding: "0",
                    borderRadius: "8px",
                    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.15)",
                    border: "none",
                    overflow: "hidden"
                  }}
                >
                  <div
                    className="d-flex justify-content-between align-items-center p-3 border-bottom"
                    style={{ backgroundColor: "#f8f9fa" }}
                  >
                    <h6 className="m-0 font-weight-bold text-dark" style={{ fontSize: "14px" }}>
                      Notifikasi
                    </h6>
                    {(() => {
                      const total = incident.getNotifikasi.totalNotifikasi;
                      return total > 0 ? (
                        <Badge variant="danger" className="p-2" style={{ fontSize: "11px", borderRadius: "12px" }}>
                          {total} Baru
                        </Badge>
                      ) : null;
                    })()}
                  </div>
                  <div style={{ maxHeight: "350px", overflowY: "auto" }}>
                    {listNotifikasi.length === 0 ? (
                      <div className="text-center text-muted py-4 w-100 d-flex flex-column align-items-center justify-content-center">
                        <i className="far fa-bell-slash d-block mb-2" style={{ fontSize: "24px", color: "#ccc" }}></i>
                        <span style={{ fontSize: "13px" }}>Tidak ada notifikasi baru</span>
                      </div>
                    ) : (
                      listNotifikasi.map((val, index) => {
                        const iconData = getNotificationIcon(val.tipe);
                        return (
                          <Dropdown.Item
                            key={val._id || index}
                            className="notification-item p-3"
                            style={{
                              whiteSpace: "normal",
                              display: "flex",
                              gap: "12px",
                              alignItems: "flex-start",
                              transition: "background-color 0.2s"
                            }}
                            href="#pablo"
                            onClick={(e) => {
                              e.preventDefault();
                              if (val.idIncidentReport) {
                                getDetailIncidentReport(dispatch, { id: val.idIncidentReport });
                                updateIsReadUserNotification(dispatch, { idUserNotifikasi: val._id });
                                setModal(true);
                              }
                            }}
                          >
                            <div
                              className="rounded-circle d-flex align-items-center justify-content-center"
                              style={{
                                width: "36px",
                                height: "36px",
                                backgroundColor: iconData.bgColor,
                                flexShrink: 0
                              }}
                            >
                              <i className={iconData.icon} style={{ color: iconData.color, fontSize: "14px" }}></i>
                            </div>
                            <div className="w-100">
                              <div className="d-flex justify-content-between align-items-baseline mb-1">
                                <span className="font-weight-bold text-dark" style={{ fontSize: "13px" }}>
                                  {iconData.label || "Info"}
                                </span>
                                {val.cabang && (
                                  <span
                                    className="text-muted font-weight-normal"
                                    style={{ fontSize: "11px", backgroundColor: "#f1f3f5", padding: "2px 6px", borderRadius: "4px" }}
                                  >
                                    <i className="fas fa-map-marker-alt mr-1" style={{ fontSize: "10px" }}></i>
                                    {val.cabang}
                                  </span>
                                )}
                              </div>
                              <p className="m-0 text-secondary" style={{ fontSize: "12px", lineHeight: "1.4" }}>
                                {val.pesan}
                              </p>
                            </div>
                          </Dropdown.Item>
                        );
                      })
                    )}
                  </div>
                </Dropdown.Menu>
              </Dropdown>
              <Dropdown as={Nav.Item}>
                <Dropdown.Toggle
                  as={Nav.Link}
                  id="dropdown-41471887333"
                  variant="default"
                >
                  <i className="nc-icon nc-bullet-list-67"></i>
                </Dropdown.Toggle>
                <Dropdown.Menu
                  alignRight
                  aria-labelledby="navbarDropdownMenuLink"
                >
                  {/* <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-email-85"></i>
                    Messages
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-umbrella-13"></i>
                    Help Center
                  </Dropdown.Item>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-settings-90"></i>
                    Settings
                  </Dropdown.Item>
                  <div className="divider"></div>
                  <Dropdown.Item
                    href="#pablo"
                    onClick={(e) => e.preventDefault()}
                  >
                    <i className="nc-icon nc-lock-circle-open"></i>
                    Lock Screen
                  </Dropdown.Item> */}
                  <Dropdown.Item
                    className="text-danger"
                    href="#pablo"
                    onClick={(e) => {
                      e.preventDefault();
                      logout();
                    }}
                  >
                    <i className="nc-icon nc-button-power"></i>
                    Log out
                  </Dropdown.Item>
                </Dropdown.Menu>
              </Dropdown>
            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal
        size="lg"
        show={modal}
        onHide={() => {
          setModal(false);
          setDataDetailIncident([]);
          dispatch({ type: "SET_GETDETAILINCIDENTREPORT", data: [] });
        }}
        aria-labelledby="example-modal-sizes-title-lg"
      >
        <Modal.Header closeButton>
          <Modal.Title
            id="example-modal-sizes-title-lg"
            style={{ fontWeight: "bold" }}
          >
            Detail
          </Modal.Title>
        </Modal.Header>
        <div style={{ maxHeight: "800px", overflowY: "scroll" }}>
          <Modal.Body>

            <Row>
              <Col md="12">
                <Form action="" className="form" method="">
                  <Card>
                    <Card.Body>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Incident Name
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.judul}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Submitter
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.diLaporkanOleh}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Branch
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.namaCabang}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Client
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.namaClient}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Type of Incident
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.typeIncident}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Category of Incident
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">{dataDetailIncident.kategoriKejadian}</Col>
                      </Row>

                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Date of Incident
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">
                          {moment(dataDetailIncident.incidentDate).format(
                            "DD MMM YYYY / HH:mm"
                          )}
                        </Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          Date of Reported
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="6">
                          {moment(dataDetailIncident.tanggalDilaporkan).format(
                            "DD MMM YYYY / HH:mm"
                          )}
                        </Col>
                      </Row>

                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          {" "}
                          Status
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">{dataDetailIncident.status}</Col>
                      </Row>
                      <Row>
                        <Col sm="5" style={{ fontWeight: "bold" }}>
                          {" "}
                          Incident Status
                        </Col>
                        <Col sm="0.5">:</Col>
                        <Col sm="5">
                          {dataDetailIncident.History &&
                            dataDetailIncident.History[0]?.statusKejadian}
                        </Col>
                      </Row>

                      <Row style={{ marginTop: 40 }}>
                        <Col
                          sm="12"
                          style={{
                            fontWeight: "bold",
                            textAlign: "center",
                            textTransform: "uppercase",
                          }}
                        >
                          History
                        </Col>
                      </Row>
                      <Row>
                        <VerticalTimeline lineColor="black">
                          {dataDetailIncident.History?.map((val, index) => {
                            return (
                              <VerticalTimelineElement
                                className="vertical-timeline-element--work"
                                contentStyle={{
                                  background: "rgb(255, 255, 255)",
                                  color: "rgb(0, 0, 0)",
                                  boxShadow: "0 10px 10px rgb(186, 186, 186)",
                                }}
                                contentArrowStyle={{
                                  borderRight: "6px solid rgb(196, 199, 200)",
                                }}
                                date={
                                  <span
                                    style={{
                                      marginLeft: "15px",
                                      marginRight: "15px",
                                    }}
                                  >
                                    {moment(val.tanggalUpdate).format(
                                      "DD MMM YYYY / HH:mm"
                                    )}
                                  </span>
                                }
                                key={index}
                                iconStyle={{
                                  background:
                                    val.statusKejadian === "Initial Report"
                                      ? "rgb(33, 150, 243)"
                                      : val.statusKejadian === "Follow-Up"
                                        ? "rgb(255, 183, 0)"
                                        : "rgb(105, 255, 0)",
                                  color: "#fff",
                                }}
                              // icon={<WorkIcon />}
                              >
                                <h4
                                  style={{ marginTop: 0, fontWeight: "bold" }}
                                >
                                  {val.statusKejadian}
                                </h4>
                                <hr
                                  style={{
                                    borderTop:
                                      val.statusKejadian === "Initial Report"
                                        ? "3px solid rgb(33, 150, 243)"
                                        : val.statusKejadian === "Follow-Up"
                                          ? "3px solid rgb(255, 183, 0)"
                                          : "3px solid rgb(105, 255, 0)",
                                  }}
                                />
                                {val.statusKejadian ===
                                  "Initial Report" ? null : (
                                  <Row>
                                    <Col
                                      sm="6"
                                      style={{
                                        fontWeight: "bold",
                                        fontSize: 14,
                                      }}
                                    >
                                      Responded By
                                    </Col>
                                    <Col sm="0.5">:</Col>
                                    <Col
                                      sm="5"
                                      style={{
                                        fontSize: 14,
                                      }}
                                    >
                                      {val.diresponOleh}
                                    </Col>
                                  </Row>
                                )}

                                <Row>
                                  <Col
                                    sm="6"
                                    style={{ fontWeight: "bold", fontSize: 14 }}
                                  >
                                    Description
                                  </Col>
                                  <Col sm="0.5">:</Col>
                                </Row>
                                <Row>
                                  <Col sm="12">{val.deskripsi}</Col>
                                </Row>
                                <Row>
                                  <Col
                                    sm="12"
                                    style={{
                                      marginTop: "10px",
                                      fontWeight: "bold",
                                    }}
                                  >
                                    Documentation
                                  </Col>
                                </Row>
                                <Row>
                                  {(dataDetailIncident?.urlPreview || []).filter(
                                    (id) => id.idDokumentasi === val._id
                                  ).length === 0 ? (
                                    <Col
                                      sm="12"
                                      style={{ textAlign: "center" }}
                                    >
                                      Documentation is Not Available
                                    </Col>
                                  ) : loading ? (
                                    <div
                                      className="loader-container"
                                      style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        textAlign: "center",
                                        width: "100%",
                                      }}
                                    >
                                      <ColorRing
                                        visible={true}
                                        height="80"
                                        width="80"
                                        ariaLabel="color-ring-loading"
                                        wrapperStyle={{}}
                                        wrapperClass="color-ring-wrapper"
                                        colors={[
                                          "#6c757d",
                                          "#6c757d",
                                          "#6c757d",
                                          "#6c757d",
                                          "#6c757d",
                                        ]}
                                      />
                                      <p
                                        style={{
                                          display: "flex",
                                          justifyContent: "center",
                                          alignItems: "center",
                                          fontSize: 19,
                                        }}
                                      ></p>
                                    </div>
                                  ) : (
                                    (dataDetailIncident?.urlPreview || [])
                                      .filter(
                                        (id) => id.idDokumentasi === val._id
                                      )
                                      .map((img) => {
                                        return (
                                          <>
                                            <Col
                                              sm="12"
                                              key={img.idDokumentasi}
                                            >
                                              <Image
                                                src={img.url}
                                                style={{
                                                  width: 200,
                                                  height: 250,
                                                  margin: 20,
                                                }}
                                                thumbnail
                                                onClick={() => {
                                                  setModalPreviewFoto(img.url);
                                                }}
                                              />
                                            </Col>
                                          </>
                                        );
                                      })
                                  )}
                                </Row>
                                {/* <Col sm="5">{val.deskripsi}</Col> */}
                              </VerticalTimelineElement>
                            );
                          })}
                        </VerticalTimeline>
                      </Row>
                      {/* <Row>
                        {(() => {
                          const closedHistory = dataDetailIncident.History?.find(
                            (h) => h.statusKejadian === "Closed"
                          );
                          const finalDocs = closedHistory
                            ? (dataDetailIncident.urlPreview || []).filter(
                              (img) => img.idDokumentasi === closedHistory._id
                            )
                            : [];

                          return finalDocs.length === 0 ? (
                            <Col sm="12" style={{ textAlign: "center" }}>
                              Final Documentation is Not Available
                            </Col>
                          ) : (
                            finalDocs.map((img, index) => {
                              return (
                                <Col sm="4" key={index}>
                                  <Image
                                    src={img.url}
                                    style={{
                                      width: 200,
                                      height: 250,
                                      margin: 20,
                                    }}
                                    thumbnail
                                    onClick={() => {
                                      setModalPreviewFoto(img.url);
                                    }}
                                  />
                                </Col>
                              );
                            })
                          );
                        })()}
                      </Row> */}
                    </Card.Body>
                  </Card>
                </Form>
              </Col>
            </Row>
          </Modal.Body>
        </div>
      </Modal>
      <div
        id="previewImage"
        style={{
          display: modalPreviewFoto ? "block" : "none",
          position: "fixed",
          top: "0",
          left: "0",
          width: "100%",
          height: "100%",
          backgroundColor: "rgba(0, 0, 0, 0.7)",
          zIndex: "9999",
          justifyContent: "center",
          alignItems: "center",
        }}
      >
        <img
          src={modalPreviewFoto}
          alt="Preview"
          style={{
            borderRadius: "5px",
            boxShadow: "4px 4px 8px 0px rgba(0,0,0,0.75)",
            maxHeight: "80%",
            maxWidth: "80%",
            objectFit: "contain",
            background: "transparent",
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
          }}
        />
        <button
          style={{
            position: "absolute",
            top: "10px",
            right: "10px",
            fontSize: "20px",
            cursor: "pointer",
          }}
          onClick={() => setModalPreviewFoto("")}
        >
          &times;
        </button>
      </div>
    </>
  );
}

export default AdminNavbar;
